export default __webpack_public_path__ + "3c42a5db0387fcc0f77860a75ae14920.woff2";